import { EWhiteLabelingClient } from "../types/misc.enum";

export const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const getWhiteLabelingClient = (): EWhiteLabelingClient => {
    const origin = window.location.origin;

    if (origin.startsWith('https://ca.ridleyconsulting')) {
        return EWhiteLabelingClient.RIDLEY_CONSULTING;
    };

    return EWhiteLabelingClient.MINDSHIELD;
};